import React from 'react';
import { getOurStorageMoveProject, deleteOurStorageMoveProjectById } from '../../../../api/storage'
import PageList from '../../../../components/PageListAPI'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

const formName = 'listMoveProject'
export default function ListMoveProject(props) {
  const can = useCan()
  const head = [
    { id: 'projectName', name: 'Проект', },
    { id: 'storageSpace', name: 'Склад', },
    { id: 'statusRus', name: 'Статус', },
    { id: 'date', name: 'Дата', type: 'date' },
  ]
  return (
    <div className='App-paper'>
      <PageList
        name={formName}
        columns={head}
        title='Документ перемещения материалов со склада на проект'
        createItem={can(SLUGS.STORAGE.MATERIAL.MOVE_MANAGE)}
        deleteItem={can(SLUGS.STORAGE.MATERIAL.MOVE_MANAGE)}
        idName='id'
        history={props.history}
        match={props.match}
        location={props.location}
        loadAPI={{
          request: getOurStorageMoveProject,
          transform: (res => {
            return {
              count: res.count,
              get: res.get.map(obj => {
                return { ...obj, statusRus: (obj.allDelivery) ? 'Доставлено' : 'Заказано' }
              })
            }
          }),
        }}
        deleteAPI={deleteOurStorageMoveProjectById}
        headerInit={{
          sortBy: 'date',
          sortDirection: 'desc',
        }}
        disabledDelete={(obj) => obj.related}
      />
    </div>
  )
}


